export default __webpack_public_path__ + "static/media/hongbao.078edf94.mp3";